<div class="dash">
  <div class="dash-hero">
    <div class="dash-hero-glow"></div>
    <div class="dash-hero-inner">
      <p class="dash-ola">Olá<span *ngIf="nome">, {{ nome }}</span>!</p>
      <h1 class="dash-titulo">Painel da catequese</h1>
      <p class="dash-sub">
        Use o menu à esquerda ou os atalhos abaixo — tudo com a cara
        <strong class="dash-brand">DOMUS DATA</strong>.
      </p>
    </div>
  </div>

  <div class="dash-cards">
    <nb-card *ngIf="showGestao" class="dash-card dash-card--pessoas">
      <nb-card-header>Pessoas</nb-card-header>
      <nb-card-body> Cadastro e edição de catequizandos (nome, CPF, contatos). </nb-card-body>
      <nb-card-footer>
        <a routerLink="/pessoas" nbButton status="info" fullWidth>Abrir pessoas</a>
      </nb-card-footer>
    </nb-card>

    <nb-card *ngIf="showGestao" class="dash-card dash-card--turmas2">
      <nb-card-header>Turmas</nb-card-header>
      <nb-card-body> Turmas, horários, ano e links para inscrição pública e frequência. </nb-card-body>
      <nb-card-footer>
        <a routerLink="/turmas" nbButton status="success" fullWidth appearance="outline">Ir para turmas</a>
      </nb-card-footer>
    </nb-card>

    <nb-card *ngIf="showMinhasTurmas" class="dash-card dash-card--minhas">
      <nb-card-header>Minhas turmas</nb-card-header>
      <nb-card-body> Acesse rapidamente a frequência das turmas em que você é catequista. </nb-card-body>
      <nb-card-footer>
        <a routerLink="/minhas-turmas" nbButton status="warning" fullWidth>Ver minhas turmas</a>
      </nb-card-footer>
    </nb-card>

    <nb-card *ngIf="showAdmin" class="dash-card dash-card--usuarios">
      <nb-card-header>Usuários</nb-card-header>
      <nb-card-body> Cadastro e perfis (admin, coordenação, catequista). </nb-card-body>
      <nb-card-footer>
        <a routerLink="/usuarios" nbButton status="danger" fullWidth appearance="outline">Gerir usuários</a>
      </nb-card-footer>
    </nb-card>

    <nb-card *ngIf="!showGestao && !showMinhasTurmas" class="dash-card dash-card--hint">
      <nb-card-header>Bem-vindo</nb-card-header>
      <nb-card-body>
        Seu perfil ainda não inclui acesso às telas de coordenação. Em caso de dúvida, fale com o administrador.
      </nb-card-body>
    </nb-card>
  </div>

  <div class="dash-indicadores dash-indicadores--apos-cards">
    <div class="dash-indicadores-glow"></div>
    <div class="dash-indicadores-inner">
      <h2 class="dash-indicadores-titulo">Indicadores</h2>
      <p class="dash-indicadores-sub" *ngIf="!indicadoresCarregando && indicadores && !indicadoresErro">
        Turmas ativas, matrículas e frequência da <strong>semana anterior</strong> (segunda a domingo{{
          sufixoPeriodoSemanaAnterior
        }}).
        <span class="dash-brand">DOMUS DATA.</span>
      </p>
      <div class="dash-indicadores-loading" *ngIf="indicadoresCarregando">
        <nb-spinner status="primary" size="medium"></nb-spinner>
        <span>Carregando indicadores…</span>
      </div>
      <div class="dash-indicadores-erro" *ngIf="!indicadoresCarregando && indicadoresErro">
        <p class="dash-indicadores-erro-msg">{{ indicadoresErroDetalhe }}</p>
        <button type="button" nbButton size="small" status="basic" (click)="carregarIndicadores()">
          Tentar novamente
        </button>
      </div>
      <div class="dash-indicadores-grid" *ngIf="!indicadoresCarregando && indicadores && !indicadoresErro">
        <div class="dash-metric">
          <span class="dash-metric-valor">{{ indicadores.turmasAtivas }}</span>
          <span class="dash-metric-label">Turmas ativas</span>
        </div>
        <div class="dash-metric">
          <span class="dash-metric-valor">{{ indicadores.matriculasEmTurmasAtivas }}</span>
          <span class="dash-metric-label">Catequizandos em turmas ativas</span>
        </div>
        <a
          *ngIf="showGestao"
          class="dash-metric dash-metric--link"
          routerLink="/frequencia-semana-anterior"
          title="Ver turmas sem chamada e faltas na semana"
        >
          <span class="dash-metric-valor"
            >{{ indicadores.pessoasComPresencaSemanaAnterior }} /
            {{ indicadores.pessoasMatriculadasDistintasEmTurmasAtivas }}</span
          >
          <span class="dash-metric-label"
            >Pessoas com presença na semana anterior (do total em turmas ativas)</span
          >
        </a>
        <div *ngIf="!showGestao" class="dash-metric">
          <span class="dash-metric-valor"
            >{{ indicadores.pessoasComPresencaSemanaAnterior }} /
            {{ indicadores.pessoasMatriculadasDistintasEmTurmasAtivas }}</span
          >
          <span class="dash-metric-label"
            >Pessoas com presença na semana anterior (do total em turmas ativas)</span
          >
        </div>
        <a
          *ngIf="showGestao"
          class="dash-metric dash-metric--link"
          routerLink="/frequencia-semana-anterior"
          title="Ver turmas sem chamada e faltas na semana"
        >
          <span class="dash-metric-valor"
            >{{ indicadores.turmasComFrequenciaSemanaAnterior }} / {{ indicadores.turmasAtivas }}</span
          >
          <span class="dash-metric-label"
            >Turmas com chamada na semana anterior (do total de turmas ativas)</span
          >
        </a>
        <div *ngIf="!showGestao" class="dash-metric">
          <span class="dash-metric-valor"
            >{{ indicadores.turmasComFrequenciaSemanaAnterior }} / {{ indicadores.turmasAtivas }}</span
          >
          <span class="dash-metric-label"
            >Turmas com chamada na semana anterior (do total de turmas ativas)</span
          >
        </div>
      </div>
    </div>
  </div>

</div>
